import React, { useState, useEffect, useRef } from "react";
import { ChequeCultureLegacy } from "../../legacyforms/ChequeCultureLegacy";
import { ActionSocialeService } from "../../../service/ActionSocialeService";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Checkbox } from "primereact/checkbox";
import { InputTextarea } from 'primereact/inputtextarea';
import "./FormulaireClap.scss";
import { useSelector } from "react-redux";
import { FieldBuilder } from "./../fields/FieldBuilder";
import { Toast } from "primereact/toast";
import { FileService } from "../../../service/FileService";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ChequeCultureService } from "../../../service/ChequeCultureService";
import { LinkProviderService } from "../../../service/LinkProviderService";

export const FormulaireClap = ({mode, oldForm}) => {
    const createMode = 'create';
    const editMode = 'edit';

    const usager = useSelector((state) => state.usager.user);
    const actionSociale = useSelector((state) => state.actionSociale);

    const [mapping, setMapping] = useState([]);
    const [enfants, setEnfants] = useState(actionSociale.enfants);
    const [currentEnfant, setCurrentEnfant] = useState();
    const [currentActionSociale, setCurrentActionSociale] = useState({});

    const [selectedEnfant, setSelectedEnfant] = useState(null);
    const [dateRange, setDateRange] = useState([])
    const [montantFrais, setMontantFrais] = useState();

    const [justificatifEnfant, setJustificatifEnfant] = useState([]);
    const [justificatifPresence, setJustificatifPresence] = useState([]);

    const [justificatifSupplementInformations, setJustificatifSupplementInformations] = useState([]);

    const [retourJustificatifEnfant, setRetourJustificatifEnfant] = useState(false);
    const [retourJustificatifPresence, setRetourJustificatifPresence] = useState(false);

    const [recapEnfant, setRecapEnfant] = useState('');

    const [policyOne, setPolicyOne] = useState(false);
    const [policyTwo, setPolicyTwo] = useState(false);

    const [displayBasic, setDisplayBasic] = useState(false);
    const [showFileUploadError, setShowFileUploadError] = useState(false);
    const [showDemandeError, setShowDemandeError] = useState(false);

    const [disabled, setDisabled] = useState(false);
    const [codeError, setCodeError] = useState(false);

    const [step, setStep] = useState(0);
    const [activeIndex, setActiveIndex] = useState([]);

    const actionSocialeService = new ActionSocialeService();
    const fileService = new FileService();
    const chequeCultureService = new ChequeCultureService();
    const linkService = new LinkProviderService();

    const toast = useRef(null);

    const editJustificatifMsg = 'Merci de renvoyer un document conforme.'

    const text =<div><p>Politique de protection des données à caractère personnel</p>
        <p>J'ai bien noté que les données à caractère personnel renseignées dans ce formulaire seront recueillies et traitées par le C.G.O.S pour la gestion des demandes d'actions et de prestations.</p>
        <p>Elles pourront également être transmises, si nécessaire pour l'exécution des demandes d'actions et de prestations et pour le respect par le C.G.O.S de ses obligations légales et réglementaires, à des tiers fournisseurs des actions et prestations, sous-traitants du C.G.O.S notamment pour la gestion informatique et financière, en cas d'obligation légale aux autorités publiques, commissaires aux comptes, avocats, experts-comptables.</p>
        <p>Si certains de ces destinataires devaient se situer en dehors de l'Union Européenne, le C.G.O.S concevra des garanties spécifiques pour assurer la protection de vos données.</p>
        <p>Les informations collectées sont conservées tout au long de votre adhésion, puis à l'expiration de celle-ci pendant le délai de prescription.</p>
        <p>Conformément au Règlement (UE) 2016/679 du Parlement européen et du Conseil sur les données (ci-après « RGPD ») et à la loi n° 78/17 du 6 janvier 1978 modifiée, relative à l'informatique, aux fichiers et aux libertés, je dispose d'un droit d'accès, de rectification, d'effacement, d'opposition et de portabilité de l'ensemble des données me concernant collectées par le C.G.O.S, en tant que responsable de traitement.</p>
        <p>Pour exercer ce droit ou pour toute réclamation, je peux adresser un courrier au C.G.O.S à l'attention du Délégué à la Protection des Données : 101 rue de Tolbiac, 75654 PARIS CEDEX 13, ou un mail à l'adresse : dpd@cgos.asso.fr, en joignant à mon envoi par voie postale ou par mail une copie d'un titre d'identité.</p></div>



    const mimeTypes = ["application/pdf", "image/jpg", "image/jpeg", "image/png"];

    const descriptionCategorie1="Une facture établie à mon nom et faisant apparaître le coût, le nom et le prénom de l'enfant et les dates de la période concernée.";
    const descriptionCategorie11="Une facture établie à mon nom et faisant apparaître le coût, le nom et le prénom de l'enfant et les dates de la garde concernée.";
    const descriptionCategorie111Bis="Une facture établie à mon nom et faisant apparaître le coût, le nom et le prénom de l'enfant et les dates de la période et de la garde concernée.";

    const justificatifsCategories1 = [
        { "key": "5526A", "value": "Centre de loisirs et stage sportifs sans Hébergement" ,"description":descriptionCategorie1},
        { "key": "5526B", "value": "Garderie du matin et du soir, avant ou aprés l'école, organisée par la mairie ou l'école","description":descriptionCategorie11 }
    ];

    const justificatifsCategories1Bis = [
            { "key": "5526", "value": "Centre de loisirs et stage sportifs sans Hébergement ou Garderie du matin et du soir, avant ou aprés l'école, organisée par la mairie ou l'école" ,"description":descriptionCategorie111Bis}
    ];

    const justificatifsCategories2 = [
        { "key": "5527", "value": "Soutien Scolaire" ,"description":"Une facture faisant apparaître l'identité du bénéficiaire de la prestation de service, la nature des services fournis, le montant et le numéro d'immatriculation de l'intervenant"}
    ];

    const justificatifsCategories3 = [
        { "key": "059", "value": "Justificatif de présence en établissement" ,"description":"Le document doit dater de moins d'un mois"}
    ];

    const justificatifsCategoriesSupplement = [
        { "key": "999", "value": "Document complémentaire demandé par le C.G.O.S" ,"description":""}
    ];

    const handleFilesError = (error) => {
       if(error.response === undefined){
            displayErrorFile('Un des fichiers parmi vos justificatifs est endommagé, il ne peut pas être utilisé.\nRéparez ou remplacez le fichier et réessayez.')
       }else{
            localStorage.setItem("errorMessage", error.response.data.message)
            window.location ="/#/serviceIndisponible/FH-" + error.response.data.errorId;
       }
    }

    useEffect(() => {
        if(createMode === mode) {
            fetchDataForCreation()
        } else if (editMode === mode) {
            fetchDataForEdition();
        } else {
            window.location.assign(linkService.getRetourEaLoginAgent());
        }
        initActiveIndex();
    }, []);

    useEffect(() => {
        getCurrentEnfant();
    }, [selectedEnfant]);

    useEffect(() => {
        setActiveIndex(prevState => [...prevState, step]);
    },[step]);

    const fetchDataForEdition = () => {
        let jsonObj = JSON.parse(oldForm.formJson);

        getCurrentActionSociale(actionSociale.listActionsSociale, actionSociale.cas, actionSociale.exercice);

        setMontantFrais(parseFloat(jsonObj.FORMULAIRE[3].VALEUR));
        setSelectedEnfant(parseInt(jsonObj.FORMULAIRE[0].VALEUR));
        const dateStartParts = jsonObj.FORMULAIRE[1].VALEUR.split('/');
        const dateEndParts = jsonObj.FORMULAIRE[2].VALEUR.split('/');
        const dateStart = new Date([dateStartParts[2], dateStartParts[1], dateStartParts[0]].join('-'));
        const dateEnd = new Date([dateEndParts[2], dateEndParts[1], dateEndParts[0]].join('-'));
        setDateRange([dateStart, dateEnd]);

        Object.values(oldForm.filesToUpload).forEach(file => {
//            if(file.codeJustificatif === actionSociale.cas) {
//            if(file.codeJustificatif === '5526a' || file.codeJustificatif === '5526b' || file.codeJustificatif === '5527') {
        if(justificatifsCategories1.find(e => e.key === file.codeJustificatif) || justificatifsCategories2.find(e => e.key === file.codeJustificatif) || justificatifsCategories1Bis.find(e => e.key === file.codeJustificatif)) {
                setRetourJustificatifEnfant(true);
            } else if(file.codeJustificatif === '059') {
                setRetourJustificatifPresence(true);
            }
        });
    };

    const fetchDataForCreation = () => {
        actionSocialeService.getMappingFormulaireClap(actionSociale.exercice, actionSociale.cas).then(
            (res) => {
                setMapping(res.data);
            }
        );
        getCurrentActionSociale(actionSociale.listActionsSociale, actionSociale.cas, actionSociale.exercice);
    };

    const mapEnfants = () => {
        const items = [];
        enfants.forEach(e => items.push({"key": e.pacId, "value": e.prenom + ' ' + e.nom + ' - ' + calculateAge(e.dateNaissance) + ' ans ' + ' (au 1er janvier ' + actionSociale.exercice + ')'}));
        return items;
    }

    // calcul de l'âge en fonction du 1er janvier de l'exercice
    const calculateAge = (dob1) => {
        const formattedDate = dob1.split('/');
        const firstDate = new Date(actionSociale.exercice + '-01-01');
        const birthDate = new Date([formattedDate[2], formattedDate[1], formattedDate[0]].join('/'));  // create a date object directly from `dob1` argument
        let age = firstDate.getFullYear() - birthDate.getFullYear();
        const m = firstDate.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && firstDate.getDate() > birthDate.getDate())) age--;
        return age;
    }

    const getCurrentActionSociale = (asList, cas, exercice) => {
        Object.values(asList).forEach(as => {
            if(as.codeActionSociale === cas && as.exercice === exercice) {
                setCurrentActionSociale(as);
                return;
            }
        });
    };

    const getCurrentEnfant = () => {
        if(enfants.length === 0) return;
        enfants.forEach(enfant => {
            if(enfant.pacId === selectedEnfant) {
                setCurrentEnfant(enfant);
                setRecapEnfant([enfant.prenom, enfant.nom, '-', calculateAge(enfant.dateNaissance), 'an(s)'].join(' '));
                return;
            }
        });
    };

    const initActiveIndex = () => {
        if(createMode === mode) setActiveIndex([step]);
        if(editMode === mode) setActiveIndex([0,1,2,3,4]);
    };

    const nextStep = (e, increment) => {
        e.target.disabled = true;
        e.target.classList.add("disabled");
        e.target.style.pointerEvents = "none";
        e.target.style.display = "none";
        setStep(step + increment);
    };

    const disableSubmitCreate = () => {
        if(actionSociale.optJustificatif)
            return !selectedEnfant || !dateRange || !montantFrais || !(justificatifEnfant && justificatifEnfant.length >= 1) || !(justificatifPresence && justificatifPresence.length >= 1) || !policyOne || !policyTwo || disabled;
        else
            return !selectedEnfant || !dateRange || !montantFrais || !(justificatifEnfant && justificatifEnfant.length >= 1) || !policyOne || !policyTwo || disabled;
    };

    const disableSubmitEdit = () => {
        if(actionSociale.optJustificatif)
            return !selectedEnfant || !dateRange || !montantFrais
                || !((retourJustificatifEnfant && justificatifEnfant && justificatifEnfant.length >= 1) || !retourJustificatifEnfant)
                || !((retourJustificatifPresence && justificatifPresence && justificatifPresence.length >= 1) || !retourJustificatifPresence)
                || !policyOne || !policyTwo || disabled;
        else
            return !selectedEnfant || !dateRange || !montantFrais
                || !((retourJustificatifEnfant && justificatifEnfant && justificatifEnfant.length >= 1) || !retourJustificatifEnfant)
                || !policyOne || !policyTwo || disabled;
    };

    const submitFormDemande = async (e) => {
        e.preventDefault();
        if(e.detail == 1){
            console.log("submiit");
            const jsonFormSchema = {
                        formulaire: [
                            {
                                "code": "NEA_PAC_LCI",
                                "valeur": selectedEnfant.toString()
                            },
                            {
                                "code": "NEA_DATE_DEBUT_LCI",
                                "valeur": [dateRange[0].getDate().toString().padStart(2, '0'), '/', (dateRange[0].getMonth()+1).toString().padStart(2, '0'), '/', dateRange[0].getFullYear()].join('')
                            },
                            {
                                "code": "NEA_DATE_FIN_LCI",
                                "valeur": [dateRange[1].getDate().toString().padStart(2, '0'), '/', (dateRange[1].getMonth()+1).toString().padStart(2, '0'), '/', dateRange[1].getFullYear()].join('')
                            },
                            {
                                "code": "NEA_MONTANT_FRAIS_LCI",
                                "valeur": montantFrais.toString()
                            }
                        ]
                    };

                    const demande = {
                        etape: "1",
                        exercice: actionSociale.exercice,
                        origine: "NEA",
                        codeClasseur: actionSociale.cas,
                        demandeStatutReferentiel: { id: 1 },
                        demandeDetails: [],
                    };

                    const demandeDetail = {
                        demandeType: {
                            codeActionSocial: actionSociale.cas ,
                        },
                        formJson: JSON.stringify(jsonFormSchema).toUpperCase(),
                        montant: montantFrais,
                        version: "1",
                    };

                    demande.demandeDetails.push(demandeDetail);

                    if((actionSociale.optJustificatif && selectedEnfant && (dateRange && dateRange.length > 0) && (montantFrais && montantFrais >= 30) && (justificatifEnfant && justificatifEnfant.length >= 1) && (justificatifPresence && justificatifPresence.length >= 1))
                        || (!actionSociale.optJustificatif && selectedEnfant && (dateRange && dateRange.length > 0) && (montantFrais && montantFrais >= 30) && (justificatifEnfant && justificatifEnfant.length >= 1))) {
                        setDisabled(true);

                        let periodeCouverte = ['Du ', dateRange[0].getDate().toString().padStart(2, '0'), '/', (dateRange[0].getMonth()+1).toString().padStart(2, '0'), '/', dateRange[0].getFullYear(), ' au ', dateRange[1].getDate().toString().padStart(2, '0'), '/', (dateRange[1].getMonth()+1).toString().padStart(2, '0'), '/', dateRange[1].getFullYear()].join('');
                        let justificatifsPresenceList = [];
                        let justificatifsPrestaList = [];
                        if(actionSociale.optJustificatif && justificatifPresence && justificatifPresence.length > 0){
                            Object.values(justificatifPresence).forEach(jus => {
                                justificatifsPresenceList.push(jus.category[1]);
                            });
                        }
                        if (justificatifEnfant && justificatifEnfant.length > 0) {
                            Object.values(justificatifEnfant).forEach(jus => {
                                justificatifsPrestaList.push(jus.category[1]);
                            });
                        }

            const infosDemandeClapDto = {
                "codeActionSociale": actionSociale.cas,
                "dateNaissance": currentEnfant.dateNaissance,
                "depenses": montantFrais.toString().replace('.', ',') + ' €',
                "emailPersonnel": usager.email,
                "exercice": actionSociale.exercice,
                "iban": actionSociale.iban,
                "justificatifsPresence": justificatifsPresenceList,
                "justificatifsPresta": justificatifsPrestaList,
                "libelleActionSociale": actionSociale.cas === '5527' ? 'SOUTIEN SCOLAIRE' : 'CENTRE DE LOISIRS ET ACCEUIL PERISCOLAIRE',
                "nom": usager.nom,
                "nomNaissance": usager.nomNaissance,
                "nomEnfant": currentEnfant.nom,
                "numCgos": usager.numCgos,
                "periodeCouverte": periodeCouverte,
                "positionStatutaire": actionSociale.fiche.libellePositionStatutaire,
                "prenom": usager.prenom,
                "prenomEnfant": currentEnfant.prenom,
                "qf": actionSociale.fiche.quotientFamilial,
                "situationAdministrative": actionSociale.fiche.libelleSituationAdministrative,
                "etbLibelle": usager.libelleEtablissement
            };
            fileService
                .uploadMultiFile(justificatifEnfant.concat(justificatifPresence))
                .then((res) => {
                    if (null != res.data && res.data != undefined) {
                        fileService.createRecaputilatifDemande(infosDemandeClapDto).then((response) => {
                            showInfo("Justificatif");
                            saveDemande(demande);
                        });
                    } else {
                        setShowFileUploadError(true);
                    }
                })
                .catch((err) => {
                    handleFilesError(err);
                }).finally(() => {
                    setDisabled(false);
                });
            }
        }
    };

    const saveDemande = (demande) => {
        chequeCultureService
            .submitDemandeForm(demande)
            .then((res) => {
                setDisplayBasic(true);
                showInfo("Demande");
            })
            .catch((err) => {
                window.location = "/#/serviceIndisponible/" + err.response.data.errorId;
            });
    };


    const displayError = (message) => {
        toast.current.show({
            severity: "error",
            summary: "ERREUR",
            detail: message,
            life: 5000,
        });
    }

    const displayErrorFile = (message) => {
                toast.current.show({
                    severity: "error",
                    summary: "ERREUR DE FICHIER",
                    detail: message,
                    life: 5000,
                });
            }

   // constitution de la liste des justifs à uploader en cas ce complément d'info
   let libelleJustifToDisplay = [];
   let codeJustifToUploadList = [];
   let cloneJustifToUploadList = [];

   if (oldForm != null && oldForm.filesToUpload != null && oldForm.filesToUpload.length > 0) {
        Object.values(oldForm.filesToUpload).forEach(file => {
            if(!codeJustifToUploadList.includes(file.codeJustificatif)){
                codeJustifToUploadList.push(file.codeJustificatif);
            }
            cloneJustifToUploadList.push(file.codeJustificatif);
            libelleJustifToDisplay.push(file.libelleJustificatifMotifSpecifique);
        });
        if(oldForm.siSupplementInfo){
            codeJustifToUploadList.push(justificatifsCategoriesSupplement[0].key);
            cloneJustifToUploadList.push(justificatifsCategoriesSupplement[0].key);
        }

    //    libelleJustifToDisplay.push(oldForm.noteRetourAgent);
    }

    const submitEditedDemande = async (e) => {
        e.preventDefault();

        // On recupère les codes dans justificatifEnfant
        let codeJustifEnfantList = [];
        if(justificatifEnfant != null && justificatifEnfant.length >=1){
            Object.values(justificatifEnfant).forEach(jus => {
                codeJustifEnfantList.push(jus.category[0]);
            });
       }
        // On recupère les codes dans justificatifPresence
        if(justificatifPresence != null && justificatifPresence.length >=1){
            Object.values(justificatifPresence).forEach(jus => {
                codeJustifEnfantList.push(jus.category[0]);
            });
        }

        // On recupère les codes dans justificatifSupplementInformations
        if(justificatifSupplementInformations != null && justificatifSupplementInformations.length >=1){
            Object.values(justificatifSupplementInformations).forEach(jus => {
                        codeJustifEnfantList.push(jus.category[0]);
            });
        }


        //Controle des justifs à uploader
        let recapJustifToUpload = true;
        let cloneJustifToUploadListSpliced = [].concat(cloneJustifToUploadList);
        if(codeJustifToUploadList != null && codeJustifToUploadList.length >=1){
            Object.values(codeJustifEnfantList).forEach(jusCode => {
                if(cloneJustifToUploadListSpliced.includes(jusCode) && cloneJustifToUploadListSpliced.indexOf(jusCode) > -1){
                    cloneJustifToUploadListSpliced.splice(cloneJustifToUploadListSpliced.indexOf(jusCode), 1);
                }
            });

            if(cloneJustifToUploadListSpliced.length >=1){
                recapJustifToUpload = false;
            }
            if(recapJustifToUpload == false){
                displayError('Un ou plusieurs des documents demandés sont manquants. Merci de compléter votre réponse.');
                return;
            }
        }


         if(e.detail == 1){
            const jsonFormSchema = {
                        formulaire: [
                            {
                                "code": "NEA_PAC_LCI",
                                "valeur": selectedEnfant.toString()
                            },
                            {
                                "code": "NEA_DATE_DEBUT_LCI",
                                "valeur": [dateRange[0].getDate().toString().padStart(2, '0'), '/', (dateRange[0].getMonth()+1).toString().padStart(2, '0'), '/', dateRange[0].getFullYear()].join('')
                            },
                            {
                                "code": "NEA_DATE_FIN_LCI",
                                "valeur": [dateRange[1].getDate().toString().padStart(2, '0'), '/', (dateRange[1].getMonth()+1).toString().padStart(2, '0'), '/', dateRange[1].getFullYear()].join('')
                            },
                            {
                                "code": "NEA_MONTANT_FRAIS_LCI",
                                "valeur": montantFrais.toString()
                            }
                        ]
                    };

                    const demande = {
                        montantTotal: montantFrais,
                        demandeId: oldForm.demandeId,
                        recordId: oldForm.recordId,
                        filesToUpload: oldForm.filesToUpload,
                        formJson: JSON.stringify(jsonFormSchema).toUpperCase(),
                        codeActionSociale: oldForm.codeActionSociale,
                        exercice: oldForm.exercice
                    };

                    if((selectedEnfant && (dateRange && dateRange.length > 0) && (montantFrais && montantFrais >= 30)
                        && ((retourJustificatifEnfant && justificatifEnfant && justificatifEnfant.length >= 1) || !retourJustificatifEnfant)
                        && ((retourJustificatifPresence && justificatifPresence && justificatifPresence.length >= 1) || !retourJustificatifPresence))
                        || ((!actionSociale.optJustificatif && selectedEnfant && (dateRange && dateRange.length > 0) && (montantFrais && montantFrais >=30) && justificatifEnfant && justificatifEnfant.length)
                        && ((retourJustificatifEnfant && justificatifEnfant && justificatifEnfant.length >= 1) || !retourJustificatifEnfant))) {

                        setDisabled(true);

                        let periodeCouverte = ['Du ', dateRange[0].getDate().toString().padStart(2, '0'), '/', (dateRange[0].getMonth()+1).toString().padStart(2, '0'), '/', dateRange[0].getFullYear(), ' au ', dateRange[1].getDate().toString().padStart(2, '0'), '/', (dateRange[1].getMonth()+1).toString().padStart(2, '0'), '/', dateRange[1].getFullYear()].join('');
                        let justificatifsPresenceList = [];
                        let justificatifsPrestaList = [];
                        if( justificatifPresence && justificatifPresence.length > 0){
                            Object.values(justificatifPresence).forEach(jus => {
                                justificatifsPresenceList.push(jus.category[1]);
                            });
                        }
                        if (justificatifEnfant && justificatifEnfant.length > 0) {
                            Object.values(justificatifEnfant).forEach(jus => {
                                justificatifsPrestaList.push(jus.category[1]);
                            });
                        }

            const infosDemandeClapDto = {
                "codeActionSociale": actionSociale.cas,
                "dateNaissance": currentEnfant.dateNaissance,
                "depenses": montantFrais.toString().replace('.', ',') + ' €',
                "emailPersonnel": usager.email,
                "exercice": actionSociale.exercice,
                "iban": actionSociale.iban,
                "justificatifsPresence": justificatifsPresenceList,
                "justificatifsPresta": justificatifsPrestaList,
                "libelleActionSociale": actionSociale.cas === '5527' ? 'SOUTIEN SCOLAIRE' : 'CENTRE DE LOISIRS ET ACCEUIL PERISCOLAIRE',
                "nom": usager.nom,
                "nomNaissance": usager.nomNaissance,
                "nomEnfant": currentEnfant.nom,
                "numCgos": usager.numCgos,
                "periodeCouverte": periodeCouverte,
                "positionStatutaire": actionSociale.fiche.libellePositionStatutaire,
                "prenom": usager.prenom,
                "prenomEnfant": currentEnfant.prenom,
                "qf": actionSociale.fiche.quotientFamilial,
                "situationAdministrative": actionSociale.fiche.libelleSituationAdministrative,
                "etbLibelle": usager.libelleEtablissement
            };
            let recordIds=oldForm.filesToUpload.map(file => file.recordId);
            let categories=oldForm.filesToUpload.map(file => file.codeJustificatif);


            fileService
                .uploadEditedFiles(justificatifEnfant.concat(justificatifPresence).concat(justificatifSupplementInformations),recordIds,codeJustifToUploadList)
                .then((res) => {
                    if (null != res.data && res.data != undefined) {
                        fileService.updateRecaputilatifDemande(infosDemandeClapDto, demande.demandeId).then((response) => {
                            showInfo("Justificatif");
                            saveEditedDemande(demande);
                        });
                    } else {
                        setShowFileUploadError(true);
                    }
                })
                .catch((err) => {
                    handleFilesError(err);
                }).finally(() => {
                setDisabled(false);
            });
            }
        }
    };

    const saveEditedDemande = (demande) => {
        chequeCultureService
            .submitEditedForm(demande)
            .then((res) => {
                setDisplayBasic(true);
                showInfo("Demande");
            })
            .catch((err) => {
                window.location = "/#/serviceIndisponible/" + err.response.data.errorId;
            });
    };

    const showInfo = (msg) => {
        toast.current.show({
            severity: "info",
            summary: "Succès",
            detail: msg + " envoyée avec succès. ",
            life: 5000,
        });
    };

    const basicDialogFooter = (
        <Button
            type="button"
            label="RETOUR ESPACE AGENT"
            onClick={(e) => logoutRemoveData(e)}
            className="btn_submit_modal"
        />
    );

    const logoutRemoveData = (e) => {
        chequeCultureService.logOut().then((res) => {
            console.log(res);
        });
        handleAnnuler();
    };

    const handleAnnuler = () => {
        chequeCultureService.redirectEaLegacy();
    };

    return (
        <div className="formClap" style={{ marginTop: "1%" }}>
            <ChequeCultureLegacy />
            <Toast ref={toast} position="top-center" className="toast-position" />
            {(actionSociale.fiche.siDodEncours || (!actionSociale.fiche.siDodEncours && actionSociale.iban) ) && actionSociale.enfants && actionSociale.enfants.length > 0 && actionSociale.fiche.droits.prestationSansCr &&
            <div className="mx-auto">
                <div className="no_shadow_no_border card" style={{padding:0}}>
                    {(mapping &&
                    <form
                        action=""
                        id="espaceAgent"
                        method="POST"
                        name="formClap"
                        className="form-horizontal cld-form-padding"
                    >

                <Accordion activeIndex={activeIndex} multiple
                                              onTabChange={(e) => setActiveIndex(e.index)}>
                    <AccordionTab header="1 - Mes informations personnelles" disabled={true}>
                        <dl className="dl-horizontal">
                            <div className="form-block-wrapper">
                                <h4>Mes informations personnelles</h4>
                                <dt>Numéro C.G.O.S</dt>
                                <dd>{usager.numCgos}</dd>
                                <dt>Etablissement</dt>
                                <dd>{usager.libelleEtablissement}</dd>
                                <dt>Civilité</dt>
                                <dd>{usager.civilite}</dd>
                                <dt>Prénom</dt>
                                <dd>{usager.prenom}</dd>
                                <dt>Nom</dt>
                                <dd>{usager.nom}</dd>
{/*                                 {null != usager.nomNaissance && usager.nomNaissance != undefined && (
                                  <p>
                                    <dt>Nom de naissance</dt>
                                    <dd>{usager.nomNaissance}</dd>
                                  </p>
                                )} */}
                                <dt>EMAIL PERSONNEL</dt>
                                <dd>{usager.email}</dd>
                            </div>
                        </dl>

                        {actionSociale.iban && (<dl className="dl-horizontal">
                            <div className="form-block-wrapper">
                                <h4>Mes coordonnées bancaires</h4>
                                <dt>Références bancaires (IBAN)</dt>
                                <dd>{actionSociale.iban}</dd>
                            </div>
                        </dl>
                         )} 
                        <dl className="dl-horizontal">
                            <div className="form-block-wrapper">
                                <h4>Mon quotient familial</h4>
                                <dt>Quotient familial</dt>
                                <dd>{actionSociale.fiche.quotientFamilial ? actionSociale.fiche.quotientFamilial.toString().replace('.', ',') : "en cours de calcul ou avis d'impôt non communiqué"}</dd>
                                <dt>Montant annuel max de la prestation/enfant</dt>
                                <dd>{actionSociale.maxVal} €</dd>
                            </div>
                        </dl>
                        <p className="form-block-info">
                            Si certaines informations sont incorrectes, vous pouvez selon les cas : <br/>
                            •    corriger depuis la rubrique <a href={linkService.getRetourEaMembreFiche()}> <b>Mes infos -> Données personnelles</b><br/></a>
                            •    informer d'un changement de situation depuis la rubrique <a href={linkService.getRetourEaContacterNousChangeSituations()}> <b>Nous contacter</b></a>.
                        </p>

                        {createMode === mode &&
                        <div className="next-button-wrapper">
                            <button type="button" className="next-button button-arrow" onClick={(e) => nextStep(e, 1)} >Etape suivante</button>
                        </div>}
                    </AccordionTab>

                    <AccordionTab header="2 - L'enfant concerné par la dépense" disabled={true}>
                        <dl className="dl-horizontal">
                            <div className="form-block-wrapper">
                                <h4>Je sélectionne l'enfant concerné</h4>
                                <p className="form-block-info">
                                  Liste proposée par défaut, sous réserve pour les enfants non à charge, de contrôles du C.G.O.S à réception de la demande.
	                            </p>
                                {<FieldBuilder code={'NEA_PAC_LCI'} items={[mapEnfants(), selectedEnfant]} onValueChange={(e) => setSelectedEnfant(e.value)} disabled={editMode === mode} />}
                            </div>

                            <div className="form-block-wrapper">
                                <h4>Période(s) et montant de vos dépenses</h4>
                                <p className="form-block-info">
                                    Vous pouvez sélectionner un ou plusieurs trimestres consécutifs (s'ils ne se suivent pas, vous devez remplir plusieurs demandes).
                                </p>
                                <FieldBuilder code={'NEA_DATE_DEBUT_LCI'} items={['TRIMESTRES', actionSociale.exercice, dateRange]} onValueChange={(e) => setDateRange(e)} disabled={false}  />
                                <br/>
                                <p className="form-block-info">
                                    Montant cumulé des factures jointes à la demande. Minimum 30 €. Vous pouvez cumuler plusieurs factures pour atteindre le minimum.
                                </p>
                                <FieldBuilder code={'NEA_MONTANT_FRAIS_LCI'} items={[null, montantFrais, null, null]} onValueChange={(e) => setMontantFrais(e.value)} />
                            </div>


                        </dl>

                        <dl className="dl-horizontal" style={{ display: (editMode === mode || (montantFrais && montantFrais >= 30 ))? 'initial' : 'none' }}>
                            <div className="form-block-wrapper" style={{ border: editMode === mode && retourJustificatifEnfant ? '3px solid red' : '' }}>

                                {editMode === mode &&  (libelleJustifToDisplay.length >= 1) &&
                                <div className="info-wrapper-2" style={{backgroundColor:'lightyellow', justifyContent:'left'}}>
                                    <span style={{fontSize: "10.0pt", fontFamily: "Tahoma, sans-serif"}}>
                                        <h4>Observations du C.G.O.S sur les documents déjà transmis :</h4>

                                        {Object.entries(libelleJustifToDisplay).map(([key,val]) =>(
                                            <li>{val}</li>
                                        ))}

                                        <br></br>

                                        <h4>Autre commentaire ou document complémentaire à nous envoyer :</h4>
                                        <p>{oldForm.noteRetourAgent}</p>

                                        <p>
                                          <h4>Merci de renvoyer dans ce formulaire, après correction, les documents indiqués ci-dessus (même nombre et mêmes types).</h4>
                                        </p>
                                    </span>

                                </div>}
                                <h4>Joindre les factures justificatives de mes dépenses</h4>
                                <FieldBuilder code={'NEA_JUSTIFICATIF'} items={[mimeTypes, actionSociale.cas === '5526' ? (   ( editMode == mode && oldForm.filesToUpload[0].codeJustificatif==='5526') ? justificatifsCategories1Bis:justificatifsCategories1 ) : justificatifsCategories2, 10000000, true, retourJustificatifEnfant ? editJustificatifMsg : null,null]} onValueChange={(e) => setJustificatifEnfant(e)} disabled={false} />

                                {(editMode === mode && oldForm.siSupplementInfo) &&
                                 <dl className="dl-horizontal" >
                                  <div className="form-block-wrapper">
                                    <FieldBuilder code={'NEA_JUSTIFICATIF'} items={[mimeTypes, justificatifsCategoriesSupplement, 10000000, true, null,"testDesciption"]} onValueChange={(e) => setJustificatifSupplementInformations(e)} disabled={false} />
                                 </div>
                                </dl>}
                            </div>
                        </dl>
                        <br/>
                        


                        {createMode === mode &&
                        <div className="next-button-wrapper">
                            <button type="button"
                                    className={!selectedEnfant || dateRange.length < 2 || !montantFrais || !(justificatifEnfant && justificatifEnfant.length > 0)
                                        ? "next-button button-arrow disabled"
                                        : "next-button button-arrow"}
                                    style={!selectedEnfant || dateRange.length < 2 || !montantFrais || !(justificatifEnfant && justificatifEnfant.length > 0)
                                        ? {pointerEvents: "none"}
                                        : {}}
                                    onClick={(e) => nextStep(e, actionSociale?.optJustificatif ? 1 : 2)}
                                    disabled={!selectedEnfant || dateRange.length < 2 || (!montantFrais && montantFrais < 30) || !(justificatifEnfant && justificatifEnfant.length > 0)} >
                                Etape suivante
                            </button>
                        </div>}
                    </AccordionTab>

                    {((actionSociale?.optJustificatif  && createMode === mode )||(editMode === mode && retourJustificatifPresence ) ) ?
                    <AccordionTab header="3 - Justificatif de présence" disabled={true}>
                        <dl className="dl-horizontal" style={{ border: editMode === mode && retourJustificatifPresence ? '3px solid red' : '', display : editMode === mode && !retourJustificatifPresence ? 'none' : '' }}>
                            <div className="form-block-wrapper">
                                <FieldBuilder code={'NEA_JUSTIFICATIF'} items={[mimeTypes, justificatifsCategories3, 10000000, false, retourJustificatifPresence ? editJustificatifMsg : null]} onValueChange={(e) => setJustificatifPresence(e)} disabled={false} />
                            </div>
                        </dl>

                       {createMode === mode &&
                        <div className="next-button-wrapper">
                            <button type="button"
                                    className={!(justificatifPresence && justificatifPresence.length > 0)
                                        ? "next-button button-arrow disabled"
                                        : "next-button button-arrow"}
                                    style={!(justificatifPresence && justificatifPresence.length > 0)
                                        ? {pointerEvents: "none"}
                                        : {}}
                                    onClick={(e) => nextStep(e, 1)}
                                    disabled={!(justificatifPresence && justificatifPresence.length > 0)} >
                                Etape suivante
                            </button>
                        </div>}
                    </AccordionTab>
                    : ''}

                    <AccordionTab header={((actionSociale?.optJustificatif  && createMode === mode )||(editMode === mode && retourJustificatifPresence ) )  ? '4 - Récapitulatif de ma demande' : '3 - Récapitulatif de ma demande'} disabled={true}>
                        <dl className="dl-horizontal">
                            <div className="form-recap form-block-wrapper">
                                <dt>Année concernée</dt>
                                <dd>{ actionSociale?.exercice ? actionSociale.exercice : '' }</dd>
                                <dt>Objet de la demande</dt>
                                <dd>
                                    { currentActionSociale.codeLibelle }
                                </dd>
                                <dt>Enfant concerné</dt>
                                <dd>
                                    { recapEnfant }
                                </dd>
                                <dt>Période de la demande</dt>
                                <dd>
                                    {
                                        dateRange && dateRange.length > 1
                                        ? ['Du ', dateRange[0].getDate().toString().padStart(2, '0'), '/', (dateRange[0].getMonth()+1).toString().padStart(2, '0'), '/', dateRange[0].getFullYear(), ' au ', dateRange[1].getDate().toString().padStart(2, '0'), '/', (dateRange[1].getMonth()+1).toString().padStart(2, '0'), '/', dateRange[1].getFullYear()].join('')
                                        : ''
                                    }
                                </dd>
                                <dt>Montant total des dépenses</dt>
                                <dd>{ montantFrais ? montantFrais.toString().replace('.', ',') : 0 } €</dd>
                                <dt>Justificatif(s) fourni(s)</dt>
                                <dd>
                                    <ul>
                                        { justificatifEnfant && justificatifEnfant.length > 0 &&
                                        Object.entries(justificatifEnfant).map(([key, value], index) => <li key={index}><b className="textLongBreak">{value.file.name}</b> - {value.category[1]}</li>) }
                                    </ul>
                                </dd>
                                {
                                    (actionSociale.optJustificatif || justificatifPresence.length > 0)
                                        ?   (<div>
                                                <dt>Justificatif de présence</dt>
                                                <dd>
                                                    <ul>
                                                        { justificatifPresence && justificatifPresence.length > 0 &&
                                                        Object.entries(justificatifPresence).map(([key, value], index) => <li key={index}><b className="textLongBreak">{value.file.name}</b> - {value.category[1]}</li>) }
                                                    </ul>
                                                </dd>
                                            </div>)
                                        :   ''
                                }
                            </div>
                        </dl>

                        {createMode === mode &&
                        <div className="next-button-wrapper">
                            <button type="button" className="next-button button-arrow" onClick={(e) => nextStep(e, 1)} >Etape suivante</button>
                        </div>}
                    </AccordionTab>

                    <AccordionTab header={((actionSociale?.optJustificatif  && createMode === mode )||(editMode === mode && retourJustificatifPresence ) )  ? '5 - Signature et envoi de ma demande' : '4 - Signature et envoi de ma demande'} disabled={true}>
                        <dl className="dl-horizontal">
                            <div className="form-sign form-block-wrapper">
                                <div className="field-checkbox">
                                    <Checkbox inputId="sign1" checked={policyOne} onChange={e => setPolicyOne(e.checked)} />
                                    <label htmlFor="sign1">Je déclare sur l’honneur l’exactitude des informations concernant ma situation professionnelle, familiale et financière et je déclare être informé(e) que quiconque se rend coupable de fraude, production de documents falsifiés comme justificatifs, fausses déclarations est passible des peines d’amendes et/ou d’emprisonnement.</label>
                                </div>
                                <div className="field-checkbox">
                                    <Checkbox inputId="sign2" checked={policyTwo} onChange={e => setPolicyTwo(e.checked)} />
                                    <label htmlFor="sign2">J’ai lu et j’approuve  la politique de gestion des données à caractère personnel renseignées dans ce formulaire.</label>
                                </div>

                                <div id="textarea" >

                                    <span>{text}</span>
                                    <br></br>
                                    <p>
                                    Pour en savoir plus, consultez la <a href='https://www.cgos.info/17/politique-protection-donnees' target='_blank'>page d'information sur la politique de protection des données du C.G.O.S.</a>
                                    </p>
                                </div>
                            </div>
                        </dl>

                        <div className="info-wrapper-2">
                            <span style={{fontSize: "10.0pt", fontFamily: "Tahoma, sans-serif",}}>
                                Une fois votre demande traitée, vous recevrez une information par Email.
                                Vous pouvez également suivre son avancement depuis la rubrique{" "}
                                <a href={linkService.getRetourEaMembreSuiviDemande()}>Mes suivis{" "}</a>de votre Espace Agent.
                            </span>
                        </div>

                        <div className="form-group">
                            <div className="navButtons cld-submit-buttons">
                                <button className="btn invalide" type="button" style={{ backgroundColor: "#C9C9C9" }} name="RETOUR_PRESTATION" onClick={logoutRemoveData}>ANNULER</button>
                                { createMode == mode && <button className="btn" type="button" onClick={submitFormDemande} name="ENVOYER_MA_DEMANDE" disabled={disableSubmitCreate()}>Envoyer ma demande</button> }
                                { editMode == mode && <button className="btn" type="button" onClick={submitEditedDemande} name="ENVOYER_MA_DEMANDE" disabled={disableSubmitEdit()}>Envoyer ma demande</button> }
                            </div>
                        </div>
                   </AccordionTab>
                </Accordion>
                        <Dialog
                            closable={false}
                            header=""
                            visible={displayBasic}
                            modal
                            footer={basicDialogFooter}
                        >
                            <center>
                                <h2>
                                    Votre demande de prestation a bien été envoyée et sera étudiée prochainement. <br />{" "}
                                </h2>
                                <br />
                                <h4>
                                    Vous pouvez suivre son avancement depuis la rubrique{" "}
                                    <a href={linkService.getRetourEaMembreSuiviDemande()}>Mes suivis{" "}</a>de votre Espace Agent.
                                </h4>
                                <br />
                            </center>
                        </Dialog>

                        <Dialog closable={false} header="" visible={showDemandeError} modal>
                            <center>
                                <h2>
                                    Un problème est survenu lors de l'envoi de votre demande de
                                    prestation : <b>{codeError}</b>
                                    <br />
                                </h2>
                                <br />
                                <h3>
                                    Pour renvoyer votre demande allez sur le formulaire de demande{" "}
                                </h3>
                                <br />
                                <br />
                                <h3>puis cliquez de nouveau sur le bouton d’envoi.</h3>
                                <br />
                                <Button
                                    type="button"
                                    label="RÉAFFICHER LE FORMULAIRE"
                                    onClick={() => window.location.reload(false)}
                                    className="btn_submit_modal"
                                />
                            </center>
                        </Dialog>

                        <Dialog
                            closable={false}
                            header=""
                            visible={showFileUploadError}
                            modal
                        >
                            <center>
                                <h2>
                                    Echec d'envoi de votre demande de prestation Chèques culture{" "}
                                    <br />
                                </h2>
                                <br />
                                <h3>
                                    En raison d’un problème technique : <b>{codeError}</b> les
                                    documents joints à votre demandes n’ont pas pu être
                                    enregistrés.
                                </h3>
                                <br />
                                <h3>
                                    Merci de nous renvoyer votre demande après vous être assuré
                                    que les documents joints à celle-ci sont conformes aux
                                    caractéristiques (taille, format) indiquées sur le formulaire.
                                </h3>
                                <br />
                                <Button
                                    type="button"
                                    label="RÉAFFICHER LE FORMULAIRE"
                                    onClick={() => window.location.reload(false)}
                                    className="btn_submit_modal"
                                />
                            </center>
                        </Dialog>
                    </form>
                    )}
                </div>
            </div>}
        </div>
    );
};
